import { tv } from 'tailwind-variants';
import styles from './ActionBar.module.scss';

const actionBarStyles = tv({
  slots: {
    actions: styles.actions,
    bar: styles.bar,
    pacing: styles.pacing,
  },
  variants: {
    reflow: {
      true: {
        actions: 'tw-h-auto tw-min-h-[1.75rem] tw-float-none tw-flex-wrap reflow-narrow:tw-h-[28px] reflow-narrow:tw-min-h-0 reflow-narrow:tw-float-left reflow-narrow:tw-flex-nowrap',
        bar: 'tw-h-auto tw-min-h-[1.875rem] tw-flex-wrap tw-gap-2 reflow-narrow:tw-h-[30px] reflow-narrow:tw-min-h-0 reflow-narrow:tw-flex-nowrap reflow-narrow:tw-gap-0',
        pacing: 'tw-h-auto tw-min-h-[1.875rem] tw-float-none tw-ml-auto reflow-narrow:tw-h-[30px] reflow-narrow:tw-min-h-0 reflow-narrow:tw-float-right reflow-narrow:tw-ml-0',
      },
    },
  },
});

export default actionBarStyles;
